export const HIDE_SCROLLBAR_CLASS = '--hide-scrollbar'
export const DISABLE_SELECTION_CLASS = '--no-select'
